// extracted by mini-css-extract-plugin
export default {"addressAction":"O3-z","loading":"P3-z"};